import React, { useState } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import HolidayManagementColumnModel from './holiday-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'
import moment from 'moment'

const HolidayManagementPage = ():any => {
  useDocumentTitle()
  const [triggerResetData, setTriggerResetData] = useState(false)

  const mappingRenderData = (data: any) => {
    return data.map((row: any) => {
      // Convert holidayDate to dd/mm/yyyy string format
      let dateStr = ''
      if (row.holidayDate) {
        const dateObj = new Date(row.holidayDate)
        if (!isNaN(dateObj.getTime())) {
          const day = String(dateObj.getDate()).padStart(2, '0')
          const month = String(dateObj.getMonth() + 1).padStart(2, '0')
          const year = dateObj.getFullYear()
          dateStr = `${day}/${month}/${year}`
        }
      }
      return {
        ...row,
        // Store the date string in dd/mm/yyyy format for editing
        holidayDate1: dateStr,
        // Map id to holidayId for delete operations
        holidayId: row.id,
        // Year is auto-calculated from date, not editable
        year: row.year || (row.holidayDate ? new Date(row.holidayDate).getFullYear() : ''),
      }
    })
  }

  const mappingUpdateData = (dataDetail: any) => {
    // Parse dd/mm/yyyy format and convert to YYYY-MM-DDT00:00:00
    if (dataDetail.holidayDate1) {
      let date: Date | null = null
      let isValidDate = false

      if (dataDetail.holidayDate1 instanceof Date) {
        date = dataDetail.holidayDate1
        isValidDate = !isNaN(date!.getTime())
      } else if (typeof dataDetail.holidayDate1 === 'string') {
        const dateStr = dataDetail.holidayDate1.trim()

        // Validate dd/mm/yyyy format using regex
        const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/
        const match = dateStr.match(dateRegex)

        if (match) {
          const day = parseInt(match[1], 10)
          const month = parseInt(match[2], 10) - 1 // months are 0-indexed in JS
          const year = parseInt(match[3], 10)

          // Validate the date values
          if (year >= 1900 && year <= 2100 && month >= 0 && month <= 11 && day >= 1 && day <= 31) {
            date = new Date(year, month, day)
            // Check if the date is valid (e.g., not 31/02/2026)
            if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
              isValidDate = true
            }
          }
        }

        if (!isValidDate) {
          // Invalid format - reject the promise to keep row in edit mode
          alert('Invalid date format. Please use dd/mm/yyyy format (e.g., 25/12/2026)')
          return null  // Return null to reject and keep row in edit mode
        }
      } else {
        date = new Date(dataDetail.holidayDate1)
        isValidDate = !isNaN(date!.getTime())
      }

      // Check if date is valid
      if (isValidDate && date) {
        // Auto-fill year from the selected date
        dataDetail.year = date!.getFullYear()
        dataDetail.holidayDate = moment(date!).format('YYYY-MM-DD') + 'T00:00:00'
      }
    }
    // Ensure year is a number
    if (dataDetail.year && typeof dataDetail.year === 'string') {
      dataDetail.year = parseInt(dataDetail.year, 10)
    }
    // Remove holidayDate1 from request (only for display)
    delete dataDetail.holidayDate1

    return dataDetail
  }

  return (
    <CommonTablePage
      urlInfoKey={urlKey.Holiday}
      title="Holiday Management"
      column={HolidayManagementColumnModel.HolidayManagementColumn}
      mappingRenderData={mappingRenderData}
      mappingUpdateData={mappingUpdateData}
      triggerResetData={triggerResetData}
    />
  )
}

export default HolidayManagementPage
